class HeaderDropdown extends HTMLElement {
  constructor() {
    super()
    this.shopToggle = this.querySelector('[data-shop-toggle]')
    this.shopDropdown = this.querySelector('[data-dropdown]')
    this.mobileToggle = this.querySelector('[data-mobile-toggle]')
    this.mobileDropdown = this.querySelector('[data-mobile-dropdown]')
    this.mobileSearchToggle = this.querySelector('[data-mobile-search-toggle]')

    this.shopAllToggle = this.querySelector('[data-shop-all-toggle]')
    this.shopOverflow = this.querySelector('[data-shop-overflow]')

    this._onDocumentClick = this.onDocumentClick.bind(this)
    this._onKeyDown = this.onKeyDown.bind(this)

    if (this.shopToggle && this.shopDropdown) {
      this.shopToggle.addEventListener('click', this.toggleShop.bind(this))
    }

    if (this.mobileToggle && this.mobileDropdown) {
      this.mobileToggle.addEventListener('click', this.toggleMobile.bind(this))
    }

    if (this.shopAllToggle) {
      this.shopAllToggle.addEventListener(
        'click',
        this.toggleShopAll.bind(this)
      )
    }

    if (this.mobileSearchToggle) {
      this.mobileSearchToggle.addEventListener(
        'click',
        this.openMobileSearch.bind(this)
      )
    }

    document.addEventListener('click', this._onDocumentClick)
    document.addEventListener('keydown', this._onKeyDown)

    // Keep --announcement-height synced for the sticky header offset
    this.announcement = document.getElementById('shopify-section-announcement-bar')
    this.updateAnnouncementHeight = () => {
      if (this.announcement) {
        document.documentElement.style.setProperty(
          '--announcement-height',
          `${this.announcement.offsetHeight}px`
        )
      }
    }
    this.updateAnnouncementHeight()
    if (this.announcement) {
      new ResizeObserver(this.updateAnnouncementHeight).observe(this.announcement)
    }
  }

  disconnectedCallback() {
    document.removeEventListener('click', this._onDocumentClick)
    document.removeEventListener('keydown', this._onKeyDown)
  }

  toggleShop(e) {
    e.stopPropagation()
    const isOpen = this.shopDropdown.classList.contains('is-open')
    this.closeAll()
    if (!isOpen) {
      this.loadMenuImages(this.shopDropdown)
      this.shopDropdown.classList.add('is-open')
      this.shopToggle.setAttribute('aria-expanded', 'true')
      this.dispatchEvent(new CustomEvent('header-dropdown:open'))
    }
  }

  toggleMobile(e) {
    e.stopPropagation()
    const isOpen = this.mobileDropdown.classList.contains('is-open')
    this.closeAll()
    if (!isOpen) {
      this.loadMenuImages(this.mobileDropdown)
      const announcement = document.getElementById('shopify-section-announcement-bar')
      const header = document.querySelector('.header')
      const topOffset = (announcement ? announcement.offsetHeight : 0) + (header ? header.offsetHeight : 0)
      this.mobileDropdown.style.marginTop = `${topOffset}px`
      this.mobileDropdown.classList.add('is-open')
      this.mobileToggle.setAttribute('aria-expanded', 'true')
      this.dispatchEvent(new CustomEvent('header-dropdown:open'))
    }
  }

  toggleShopAll(e) {
    e.stopPropagation()
    const isExpanded = this.shopOverflow.classList.contains('is-open')
    if (isExpanded) {
      this.shopOverflow.classList.remove('is-open')
      this.shopAllToggle.setAttribute('aria-expanded', 'false')
    } else {
      this.shopOverflow.classList.add('is-open')
      this.shopAllToggle.setAttribute('aria-expanded', 'true')
    }
  }

  loadMenuImages(dropdown) {
    dropdown.querySelectorAll('img[data-menu-src]').forEach((image) => {
      if (image.dataset.menuSrcset) {
        image.srcset = image.dataset.menuSrcset
        delete image.dataset.menuSrcset
      }
      image.src = image.dataset.menuSrc
      delete image.dataset.menuSrc
    })
  }

  openMobileSearch(e) {
    e.stopPropagation()
    this.closeAll()
    const searchDetails = document.querySelector('.header__search details')
    if (searchDetails) {
      searchDetails.querySelector('summary')?.click()
      setTimeout(() => {
        const input = searchDetails.querySelector('input[type="search"]')
        if (input) input.focus()
      }, 100)
    }
  }

  closeAll() {
    if (this.shopDropdown) {
      this.shopDropdown.classList.remove('is-open')
    }
    if (this.mobileDropdown) {
      this.mobileDropdown.classList.remove('is-open')
    }
    if (this.shopToggle) {
      this.shopToggle.setAttribute('aria-expanded', 'false')
    }
    if (this.mobileToggle) {
      this.mobileToggle.setAttribute('aria-expanded', 'false')
    }
    if (this.shopOverflow) {
      this.shopOverflow.classList.remove('is-open')
    }
    if (this.shopAllToggle) {
      this.shopAllToggle.setAttribute('aria-expanded', 'false')
    }
  }

  onDocumentClick(e) {
    if (
      !this.contains(e.target) ||
      e.target.closest('.header__search summary')
    ) {
      this.closeAll()
    }
  }

  onKeyDown(e) {
    if (e.key === 'Escape') {
      this.closeAll()
    }
  }
}

customElements.define('header-dropdown', HeaderDropdown)
